import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { filters2qs } from '@data-fair/components-app/filters/filters'

Vue.use(Vuex)

export default () => {
  return new Vuex.Store({
    state: {
      env: null,
      application: window.APPLICATION,
      dataset: null,
      error: null,
      loading: false,
      metrics: {},
      quantiles: null,
      colorMetrics: null,
      conceptFilters: {}
    },
    getters: {
      tileserverUrl (state) {
        return state.application.apiUrl + '/remote-services/tileserver-koumoul/proxy'
      },
      datasetUrl (state) {
        return state.application.configuration &&
          state.application.configuration.datasets &&
          state.application.configuration.datasets[0] &&
          state.application.configuration.datasets[0].href
      },
      config (state) {
        return state.application.configuration
      },
      fields (state) {
        return state.dataset && state.dataset.schema.reduce((a, b) => { a[b.key] = b; return a }, {})
      },
      radiusMetrics (state, getters) {
        return getters.config.radius && getters.config.radius.type === 'variable' ? state.metrics[getters.config.radius.field] : {}
      },
      linkField (state) {
        return state.dataset && state.dataset.schema.find(f => f['x-refersTo'] === 'https://schema.org/WebPage')
      }
    },
    mutations: {
      setAny (state, params) {
        Object.assign(state, params)
      }
    },
    actions: {
      async init ({ state, commit, dispatch, getters }) {
        if (getters.datasetUrl) {
          try {
            const dataset = (await axios.get(getters.datasetUrl)).data
            const qs = (getters.config.filters && getters.config.filters.length) ? ('_exists_:_geopoint AND ' + filters2qs(getters.config.filters)) : '_exists_:_geopoint'
            if (getters.config.colors && getters.config.colors.rangeOptions && getters.config.colors.rangeOptions.ranges && getters.config.colors.rangeOptions.ranges.type === 'quantiles') {
              const percents = [0, ...Array.from({ length: getters.config.colors.rangeOptions.ranges.size - 1 }, (_, i) => (i + 1) * (100 / getters.config.colors.rangeOptions.ranges.size)), 100].join(',')
              const metrics = (await axios.get(getters.datasetUrl + '/metric_agg', {
                params: {
                  field: getters.config.colors.rangeOptions.field,
                  metric: 'percentiles',
                  percents,
                  qs,
                  ...state.conceptFilters,
                  finalizedAt: getters.config.datasets[0].finalizedAt
                }
              })).data.metric
              commit('setAny', { quantiles: metrics.map((m, i) => ({ min: i ? metrics[i - 1].value : undefined, max: m.value })).slice(1) })
            }
            const fields = (getters.config.dynamicFilters || []).filter(filter =>
              !filter.facet &&
              (filter.field.type === 'number' || filter.field.type === 'integer' ||
              (filter.field.type === 'string' && filter.field.format === 'date'))
            ).map(filter => filter.field.key)
            if (getters.config.radius && getters.config.radius.type === 'variable' && !fields.includes(getters.config.radius.field)) fields.push(getters.config.radius.field)
            if (getters.config.colors && getters.config.colors.rangeOptions && getters.config.colors.rangeOptions.scheme.computed && !fields.includes(getters.config.colors.rangeOptions.field)) fields.push(getters.config.colors.rangeOptions.field)
            if (fields.length) {
              const metrics = (await axios.get(getters.datasetUrl + '/simple_metrics_agg', {
                params: {
                  fields: fields.join(','),
                  qs,
                  ...state.conceptFilters,
                  finalizedAt: getters.config.datasets[0].finalizedAt
                }
              })).data.metrics
              if (getters.config.radius && getters.config.radius.type === 'variable') {
                const { metric } = (await axios.get(getters.datasetUrl + '/metric_agg', {
                  params: {
                    field: getters.config.radius.field,
                    metric: 'avg',
                    qs,
                    ...state.conceptFilters,
                    finalizedAt: getters.config.datasets[0].finalizedAt
                  }
                })).data
                metrics[getters.config.radius.field].avg = metric
              }
              commit('setAny', { metrics })
              if (getters.config.colors.rangeOptions && getters.config.colors.rangeOptions.scheme.computed) {
                commit('setAny', { colorMetrics: metrics[getters.config.colors.rangeOptions.field] })
              }
            }
            commit('setAny', { dataset })
          } catch (err) {
            dispatch('setError', err)
          }
        }
      },
      async setError ({ state, commit }, error) {
        commit('setAny', { error })
        try {
          axios.post(state.application.href + '/error', { message: error.message || error })
        } catch (err) {
          console.log('Failed to report error', err)
        }
      }
    }
  })
}
